import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputColor from '../../layout/input/InputColor';

class Geral extends AbstractComponent {               
    render() {
        return(                                                                 
            <Fragment>   
                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="background_thema"
                    nome="background_thema"                    
                    value={this.props.form.background_thema}
                    defaultValue={this.props.form.background_thema}
                    erro={this.props.erroForm.background_thema}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Thema
                </InputColor> 
                
                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_thema"
                    nome="color_thema"                    
                    value={this.props.form.color_thema}
                    defaultValue={this.props.form.color_thema}
                    erro={this.props.erroForm.color_thema}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Thema
                </InputColor> 

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="background_button"
                    nome="background_button"                    
                    value={this.props.form.background_button}
                    defaultValue={this.props.form.background_button}
                    erro={this.props.erroForm.background_button}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Button
                </InputColor> 

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="color_button"
                    nome="color_button"                    
                    value={this.props.form.color_button}
                    defaultValue={this.props.form.color_button}
                    erro={this.props.erroForm.color_button}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Button
                </InputColor> 

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="background_button_hover"
                    nome="background_button_hover"                    
                    value={this.props.form.background_button_hover}
                    defaultValue={this.props.form.background_button_hover}
                    erro={this.props.erroForm.background_button_hover}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Button Hover
                </InputColor> 

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="color_button_hover"
                    nome="color_button_hover"                    
                    value={this.props.form.color_button_hover}
                    defaultValue={this.props.form.color_button_hover}
                    erro={this.props.erroForm.color_button_hover}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Button Hover
                </InputColor>

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_link_acao"
                    nome="color_link_acao"                    
                    value={this.props.form.color_link_acao}
                    defaultValue={this.props.form.color_link_acao}
                    erro={this.props.erroForm.color_link_acao}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Link Ação
                </InputColor>

                <InputColor
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    id="color_link_remover"
                    nome="color_link_remover"                    
                    value={this.props.form.color_link_remover}
                    defaultValue={this.props.form.color_link_remover}
                    erro={this.props.erroForm.color_link_remover}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Link Remover
                </InputColor>

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="background_btn_voltar"
                    nome="background_btn_voltar"                    
                    value={this.props.form.background_btn_voltar}
                    defaultValue={this.props.form.background_btn_voltar}
                    erro={this.props.erroForm.background_btn_voltar}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Button "Voltar"
                </InputColor>

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="color_btn_voltar"
                    nome="color_btn_voltar"                    
                    value={this.props.form.color_btn_voltar}
                    defaultValue={this.props.form.color_btn_voltar}
                    erro={this.props.erroForm.color_btn_voltar}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Button "Voltar"
                </InputColor>

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="background_btn_voltar_hover"
                    nome="background_btn_voltar_hover"                    
                    value={this.props.form.background_btn_voltar_hover}
                    defaultValue={this.props.form.background_btn_voltar_hover}
                    erro={this.props.erroForm.background_btn_voltar_hover}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Background Button "Voltar" Hover
                </InputColor>

                <InputColor
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    id="color_btn_voltar_hover"
                    nome="color_btn_voltar_hover"                    
                    value={this.props.form.color_btn_voltar_hover}
                    defaultValue={this.props.form.color_btn_voltar_hover}
                    erro={this.props.erroForm.color_btn_voltar_hover}                    
                    onChange={e => this.props.onChange(e)}
                >
                    Color Button "Voltar" Hover
                </InputColor>
            </Fragment>
        )
    }
}

export default Geral;